@if ({ data: (isHideActive$ | async) }; as isHideActive) {
  <button
    class="hide-button"
    (click)="onStatusClicked(isHideActive.data.status)"
    [ngClass]="{ 'hide-active': isHideActive.data.status !== HideStatusEnum.hide, 'color-dark': colorDark }">
    <span class="hide-text">{{ isHideActive.data.status | translate }}</span>
    <bp-icon icon="{{ isHideActive.data.icon }}" size="16"></bp-icon>
  </button>
}
